import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: '[wrapFocus]'
})
export class WrapFocusDirective implements OnInit {

  KEYCODE_TAB: number = 9;

    constructor(
        private hostElement: ElementRef
    ) {}
    ngOnInit(): void {
        // console.log('Wrap Focus Init');
    }

    @HostListener("document:keydown", ["$event"])
  onKeyDown(e: KeyboardEvent): any {
      if (e.key === 'Tab') {
          let focusableEls = this.hostElement.nativeElement;
          let modalContent = $(focusableEls).find('a, :input, [tabindex]');
          var firstFocusableEl = modalContent.first()[0];
          var lastFocusableEl = modalContent.last()[0];

          if (e.shiftKey) /* shift + tab */ {
              console.log(firstFocusableEl, lastFocusableEl, document);
              if (document.activeElement === firstFocusableEl) {
                  lastFocusableEl.focus();
                  e.preventDefault();
              }
          } else /* tab */ {
              console.log(firstFocusableEl, lastFocusableEl, document);
              if (document.activeElement === lastFocusableEl) {
                  firstFocusableEl.focus();
                  e.preventDefault();
              }    
          }
      }
  }
}